import { clusterLines } from "@/lib/prompt-module";

type Props = {
  /** Prompts des Topics, die geordnet werden (ohne verworfene). */
  count: number;
  busy: boolean;
  error: string | null;
  onStart: () => void;
  onCancel: () => void;
};

/** Rückfrage vor dem Clustern: Umfang und Kosten stehen vor dem Start da, die alten Tags werden ersetzt. */
export function ClusterDialog({ count, busy, error, onStart, onCancel }: Props) {
  return (
    <div
      role="group"
      aria-label="Clustern bestätigen"
      className="flex flex-col gap-3 rounded-lg border border-line bg-white px-5 py-4 text-sm"
    >
      <h2 className="text-base font-semibold">Prompts neu clustern?</h2>
      <p className="text-[13px] text-muted">
        Gemini ordnet alle Prompts des Topics (ohne verworfene) thematisch und vergibt je Cluster einen Tag. Vorhandene Tags werden ersetzt.
        Nach jedem Generieren werden neue Prompts automatisch eingeordnet, bestehende Tags bleiben dabei erhalten.
      </p>
      <ul className="flex flex-col gap-0.5">
        {clusterLines(count).map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      {error && (
        <p role="alert" className="text-[13px] text-danger">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy || count === 0}
          onClick={onStart}
          className="h-11 rounded-md bg-accent px-3.5 text-sm font-medium text-white disabled:opacity-60"
        >
          {busy ? "Wird gestartet …" : "Clustern starten"}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-field bg-white px-3.5 text-sm">
          Abbrechen
        </button>
      </div>
    </div>
  );
}
